<ng-container *ngIf="!isDeclined; else declinedTemplate">
  <h3>Before we continue, please review and accept the following:</h3>
  <hfc-spinner *ngIf="isLoading"></hfc-spinner>
  <div *ngIf="!isLoading" class="terms-and-conditions-text" [innerHTML]="termsAndConditions?.text | sanitizeHtml"></div>
</ng-container>

<ng-template #declinedTemplate>
  <div class="declined-terms-and-conditions">
    <h2>Declined Terms & Conditions</h2>
    <hfc-terms-and-conditions-declined></hfc-terms-and-conditions-declined>
  </div>
</ng-template>
